import { useEffect, useState } from 'react'
import { IndividualTelItem, ReactState } from '../../../../../../React/Common/Types/Types'
import { isVarNotEmpty } from '../../../../../../NonReact/utils/GlobalFunctions'
import { ALL_VALUE } from '../../../../../../React/Common/Constants/DefaultValues'
import { getTelephonyServer } from '../../../../../../React/Common/API/ItemsGetters'
import { $error } from '../../../../../../React/Common/Utils/ConsoleUtils'
import { useWatch } from '../../../../../../Vendor/react-hook-form/dist/index.ie11'

export const useTelSysType = (telSysIDName: string): Definable<string> => {
    const [telSysType, setTelSysType]: ReactState<Definable<string>> = useState<Definable<string>>()

    const telSysValue: Definable<number> = useWatch({
        name: telSysIDName
    })

    useEffect((): void => {
        if (isVarNotEmpty(telSysValue) && telSysValue !== ALL_VALUE) {
            getTelephonyServer(telSysValue)
                .then((telSys: Nullable<IndividualTelItem>): void => setTelSysType(telSys?.TelSysType))
                .catch($error)
        }
    }, [telSysValue])

    return telSysType
}
